import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import FinanceTab from './FinanceTab';
import CashTab from './CashTab';

import css from './PurchaseOptions.module.css';

const TABS = {
  finance: 'finance',
  cash: 'cash',
};

/**
 * Purchase Options -- Finance/Cash toggle shown on every vehicle listing,
 * for private-seller, dealer, broker and business/wholesaler vehicles alike.
 * Renders on top of the existing calculationEngine.js math (amortization,
 * tax-rate tables, GAP/warranty tiering) rather than a separate estimator.
 */
export default function PurchaseOptions({
  vehiclePrice,
  vehicleYear,
  vehicleKm,
  vehicleCategory = 'automotive',
  province = 'MB',
  sellerType,
  listingId,
  lenderRates = [],
  inServiceDate,
  historyScreen = null,
}) {
  const [activeTab, setActiveTab] = useState(TABS.finance);

  return (
    <div className={css.root}>
      <div className={css.tabBar} role="tablist">
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === TABS.finance}
          className={`${css.tabButton} ${activeTab === TABS.finance ? css.tabButtonActive : ''}`}
          onClick={() => setActiveTab(TABS.finance)}
        >
          <FormattedMessage id="PurchaseOptions.financeTab" />
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === TABS.cash}
          className={`${css.tabButton} ${activeTab === TABS.cash ? css.tabButtonActive : ''}`}
          onClick={() => setActiveTab(TABS.cash)}
        >
          <FormattedMessage id="PurchaseOptions.cashTab" />
        </button>
      </div>

      <div className={css.tabContent}>
        {activeTab === TABS.finance ? (
          <FinanceTab
            vehiclePrice={vehiclePrice}
            vehicleYear={vehicleYear}
            vehicleKm={vehicleKm}
            vehicleCategory={vehicleCategory}
            province={province}
            sellerType={sellerType}
            listingId={listingId}
            lenderRates={lenderRates}
            inServiceDate={inServiceDate}
            historyScreen={historyScreen}
          />
        ) : (
          <CashTab
            vehiclePrice={vehiclePrice}
            province={province}
            sellerType={sellerType}
            listingId={listingId}
            vehicleCategory={vehicleCategory}
            inServiceDate={inServiceDate}
            vehicleKm={vehicleKm}
          />
        )}
      </div>

      <p className={css.disclaimer}>
        <FormattedMessage id="PurchaseOptions.disclaimer" />
      </p>
    </div>
  );
}
